export function getStyle(_ref) {
  var isSelected = _ref.isSelected,
      highlightedInSearch = _ref.highlightedInSearch,
      hover = _ref.hover,
      isDragging = _ref.isDragging,
      someoneDragging = _ref.someoneDragging,
      canDrop = _ref.canDrop,
      isOver = _ref.isOver;
  var background;
  var opacity;
  var color = '#000335';

  if (hover) {
    background = '#F4F4F8';
  }

  if (isSelected) {
    background = 'rgba(92, 130, 229, 0.15)';
  }

  if (highlightedInSearch) {
    background = 'rgba(125, 177, 255, 0.15)';

    if (hover) {
      background = 'rgba(125, 177, 255, 0.30)';
    }
  }

  if (someoneDragging) {
    background = 'inherit';
  }

  if (someoneDragging && !canDrop) {
    opacity = '0.6';
  }

  if (canDrop) {
    opacity = '1';
  }

  if (isOver && canDrop) {
    background = 'rgba(92, 130, 229, 0.1)';
  }

  return {
    background: background,
    color: color,
    opacity: opacity
  };
}